module.exports = __webpack_public_path__ + "static/prodinity_main_8-9ffe6978b567ef3c51af2f3a820ffd0f.png";